import React from 'react';
import { ToothZapFooter2 } from "../layouts/footernew";
import { Nav } from '../layouts/header';



export const Blogcomingsoon: React.FC = () => {
      return (
         <div>
                    
               </div>
         
      );
};



export default Blogcomingsoon;